class Nielsen {

    constructor(options) {

        console.log('Nielsen Plugin');

        this.id = options.id;
        this.videoElement = options.videoElement;
        this.shakaPlayer = options.shakaPlayer;
        this.analyticsApiResponse = options.analyticsApiResponse;
        this.streamsApiResponse = options.streamsApiResponse;

        !function (e, n) {
            function t(e) {
                return "object" == typeof e ? JSON.parse(JSON.stringify(e)) : e
            }
    
            e[n] = e[n] ||
                {
                    nlsQ: function (o, r, c) {
                        var s = e.document,
                            a = s.createElement("script");
                        a.async = 1,
                            a.src = ("http:" === e.location.protocol ? "http:" : "https:") + "//cdn-gl.nmrodam.com/conf/" + o + ".js#name=" + r + "&ns=" + n;
                        var i = s.getElementsByTagName("script")[0];
                        return i.parentNode.insertBefore(a, i),
                            e[n][r] = e[n][r] || {
                                g: c || {},
                                ggPM: function (o, c, s, a, i) {
                                    e[n][r].q = e[n][r].q || [];
                                    try {
                                        var l = t([o, c, s, a, i]);
                                        e[n][r].q.push(l)
                                    } catch (e) {
                                        console && console.log && console.log("Error: Cannot register event in Nielsen SDK queue.")
                                    }
                                },
                                trackEvent: function (o) {
                                    e[n][r].te = e[n][r].te || [];
                                    try {
                                        var c = t(o);
                                        e[n][r].te.push(c)
                                    } catch (e) {
                                        console && console.log && console.log("Error: Cannot register event in Nielsen SDK queue.")
                                    }
                                }
                            },
                            e[n][r]
                    }
                }
        }(window, "NOLBUNDLE");

        this.nSdkInstance = NOLBUNDLE.nlsQ("PE02491CE-C960-418E-A57B-402CD1C42064", "nlsnInstance", {nol_sdkDebug: "DEBUG"});

        this.init();

    }

    init() {

        let firstPlay = false;
        let playTime = 0;
        let lastUpdateTime = null;
        
        this.videoElement.addEventListener('play', () => {

            if(!firstPlay) {
                this.nSdkInstance.ggPM('loadMetadata', this.analyticsApiResponse);
                this.debug('loadMetadata', this.analyticsApiResponse);
                firstPlay = true;
            }

            lastUpdateTime = null;

        });

        this.videoElement.addEventListener('timeupdate', () => {
            const currentTime = Math.floor(this.videoElement.currentTime);
            if (currentTime !== lastUpdateTime) {
                playTime = currentTime;
                lastUpdateTime = currentTime;
                const utcUnixTimestamp = Math.floor(Date.now() / 1000);
                this.debug('setPlayheadPosition = ' + playTime + ', UTC Unix Timestamp = ' + utcUnixTimestamp);
                this.nSdkInstance.ggPM('setPlayheadPosition', utcUnixTimestamp);
            }
        })
        
        this.videoElement.addEventListener('timeupdate', () => {
            const currentTime = Math.floor(this.videoElement.currentTime);
            if (currentTime !== lastUpdateTime) {
                playTime = currentTime;
                lastUpdateTime = currentTime;
                this.debug('setPlayheadPosition = ' + playTime);
                this.nSdkInstance.ggPM('setPlayheadPosition', playTime);
            }
        });

        this.videoElement.addEventListener('pause', () => {
            playTime = Math.floor(this.videoElement.currentTime);
            this.debug('stop = ' + playTime);
            this.nSdkInstance.ggPM('stop', playTime);
        });

        this.videoElement.addEventListener('ended', () => {
            playTime = Math.floor(this.videoElement.currentTime);
            this.debug('end = ' + playTime);
            this.nSdkInstance.ggPM('end', playTime);
        });
        
        // Handle tab/window closure or navigation away
        const handleTermination = () => {
            playTime = Math.floor(this.videoElement.currentTime);
            this.debug('end (terminated) = ' + playTime);
            this.nSdkInstance.ggPM('end', playTime);
        };
        
        window.addEventListener('beforeunload', handleTermination);
        document.addEventListener('visibilitychange', () => { 
            if (document.visibilityState === 'hidden') {
                handleTermination();
            }
        });

    }

    debug(msg) {
        console.log('Nielsen: ' + msg);
    }

}

export default Nielsen;